export const PermissionConst = {
  // パーミッション
  CAN_ACCESS_KINTAI: '勤怠システムへのアクセス',
  CAN_ACCESS_JINJI: '人事システムへのアクセス',
  CAN_ACCESS_SEISYAIN: '正社員の情報へのアクセス',
  CAN_ACCESS_KEIYAKU_SYAIN: '契約社員の情報へのアクセス',
  CAN_ACCESS_HAKEN_SYAIN: '派遣社員の情報へのアクセス',
  SHINSEI_SEARCH_ME: '各種申請の検索（対象：自身）',
  SHINSEI_SEARCH_SYOUNIN: '各種申請の検索（対象：承認グループ）',
  SHINSEI_SEARCH_SYOZOKU: '各種申請の検索（対象：所属先）',
  SHINSEI_SEARCH_ALL: '各種申請の検索（対象：全て）',
  SHINSEI_CREATE: '各種申請の作成',
  SHINSEI_CANCEL: '各種申請の取消（対象：自身）',
  SHINSEI_CANCEL_SYOUNIN: '各種申請の取消（対象：承認グループ）',
  SHINSEI_CANCEL_SYOZOKU: '各種申請の取消（対象：所属先）',
  SHINSEI_CANCEL_ALL: '各種申請の取消（対象：全て）',
  SYAIN_MASTER: '社員マスタ管理機能へのアクセス',
  SYAIN_MASTER_SEARCH_ALL: '社員マスタの検索（対象：全て）',
  SYAIN_MASTER_SEARCH_SYOZOKU: '社員マスタの検索（対象：所属先）',
  SYAIN_MASTER_DETAIL_ALL: '社員マスタ 詳細取得（対象：全て）',
  SYAIN_MASTER_DETAIL_SYOZOKU: '社員マスタ 詳細取得（対象：所属先）',
  SIMPLY_SYAIN_LIST: '簡易社員一覧の取得（対象：所属先）',
  SIMPLY_SYAIN_LIST_ALL: '簡易社員一覧の取得（対象：全て）',
  KOYOUKEIYAKU: '雇用契約管理機能へのアクセス',
  KOYOUKEIYAKU_SEARCH_FOR_SYOZOKU: '雇用契約の検索（対象：所属先）',
  KOYOUKEIYAKU_SEARCH_FOR_ALL: '雇用契約の検索（対象：全て）',
  KOYOUKEIYAKU_DETAIL_FOR_SYOZOKU: '雇用契約の詳細表示（対象：所属先）',
  KOYOUKEIYAKU_DETAIL_FOR_ALL: '雇用契約の詳細表示（対象：全て）',
  KOYOUKEIYAKU_SUBMIT: '雇用契約の提出',
  KOYOUKEIYAKU_CREATE: '雇用契約の作成／編集／削除（対象：所属先）',
  KOYOUKEIYAKU_CREATE_FOR_ALL: '雇用契約の作成／編集／削除（対象：全て）',
  KOYOUKEIYAKU_EIGYO: '雇用契約作成時の担当営業',
  KOYOUKEIYAKU_EIGYO_LIST: '雇用契約の担当営業一覧取得（対象：所属先）',
  KOYOUKEIYAKU_EIGYO_LIST_ALL: '雇用契約の担当営業一覧取得（対象：全て）',
  RENRAKU: '会社連絡事項 管理機能へのアクセス',
  RENRAKU_CREATE: '会社連絡事項 新規作成',
  RENRAKU_SEARCH_VIEW: '会社連絡事項 検索／閲覧',
  RENRAKU_CONTROL_ME: '会社連絡事項の管理（対象：自身）',
  RENRAKU_CONTROL_SYOZOKU: '会社連絡事項の管理（対象：所属先）',
  RENRAKU_CONTROL_ALL: '会社連絡事項の管理（対象：全て）',
  RENRAKU_CAN_ACCES_OTHER_READED: '会社連絡事項 他メンバーの既読状況の確認',
  PX: 'PX連携機能へのアクセス',
  YUUKYUU_KANRI: '有給管理台帳の検索',
  DB_MASTER: 'DBマスタ管理機能へのアクセス',
  SYSTEM_ADMIN: 'システム管理機能へのアクセス',
  GET_DAKOKU: '打刻情報の取得',
  DAKOKU_SYOUNIN: '打刻承認',
  DAKOKU_IKKATSU_SYOUNIN: '打刻一括承認',
  SOUMU_DAKOKU_KAKUNIN: '打刻一括確認',
  ZANGYOU_CHECK: '月ごとの残業時間チェック',
  KINTAI_MANAGE_FOR_HAKENSAKI: '派遣先上長 勤怠管理機能へのアクセス',
  SYUUGYOU_BASYO_GET_ALL: '全就業場所一覧の取得',
  GET_KINTAI_SUMMARY_FOR_GROUP: '勤怠サマリー取得（対象：承認グループ）',
  GET_KINTAI_SUMMARY_FOR_SYOZOKU: '勤怠サマリー取得（対象：所属先）',
  GET_KINTAI_SUMMARY_FOR_ALL: '勤怠サマリー取得（対象：全て）',
  KINMU_EDIT: '勤務編集',
  SYUUGYOU_KISOKU_VIEW_ALL: '就業規則の閲覧',
  TIME_SHEET_KAKUTEI: '月次勤怠の確定／解除'
}
